import React, { useRef } from "react";
import { Save, CheckCircle2, Pencil } from "lucide-react";

export default function SettingsTab({
  workingHours,
  onChangeWorkingHours,
  onSave,
  saving,
  updated,
  currentLogoUrl,
  logoPreviewUrl,
  onSelectLogoFile,
  onSaveLogo,
  savingLogo,
  logoUpdated,
}) {
  const logoInputRef = useRef(null);
  const displayLogoUrl = logoPreviewUrl || currentLogoUrl;

  const handleOpenFilePicker = () => {
    logoInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      onSelectLogoFile(file);
    }
    e.target.value = "";
  };

  return (
    <div>
      <h2 className="section-title">İşletme Mesai Saatleri</h2>
      <p className="section-subtitle" style={{ marginTop: 0 }}>
        İşletmenin genel açılış/kapanış saatleri. Her çalışan kendi saatlerini ayrıca ayarlayabilir.
      </p>

      <div className="settings-card">
        <div className="settings-grid">
          <div>
            <label>Açılış Saati</label>
            <input
              type="time"
              value={workingHours.start}
              onChange={(e) => onChangeWorkingHours("start", e.target.value)}
            />
          </div>
          <div>
            <label>Kapanış Saati</label>
            <input
              type="time"
              value={workingHours.end}
              onChange={(e) => onChangeWorkingHours("end", e.target.value)}
            />
          </div>
        </div>
        <button onClick={onSave} className="btn-save" disabled={saving}>
          <Save />
          {saving ? "Kaydediliyor..." : "Kaydet"}
        </button>
        {updated && (
          <p className="success-msg">
            <CheckCircle2 />
            Mesai saatleri güncellendi.
          </p>
        )}
      </div>

      <div className="settings-card" style={{ marginTop: "1rem" }}>
        <h3 className="settings-card-title">İşletme Logosu</h3>
        <div className="settings-logo-wrap">
          <button
            type="button"
            className="settings-logo-circle"
            onClick={handleOpenFilePicker}
            aria-label="Logo yükle"
          >
            {displayLogoUrl ? (
              <img src={displayLogoUrl} alt="İşletme logosu" className="settings-logo-img" />
            ) : (
              <span className="settings-logo-empty" />
            )}
          </button>

          <button
            type="button"
            className="settings-logo-edit-btn"
            onClick={handleOpenFilePicker}
            aria-label="Logo değiştir"
          >
            <Pencil />
          </button>

          <input
            ref={logoInputRef}
            type="file"
            accept=".png,image/png"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
        </div>

        <div className="settings-logo-actions">
          <button type="button" onClick={onSaveLogo} className="btn-save" disabled={savingLogo}>
            <Save />
            {savingLogo ? "Logo Kaydediliyor..." : "Logoyu Kaydet"}
          </button>
          {logoUpdated && (
            <p className="success-msg" style={{ marginTop: 0 }}>
              <CheckCircle2 />
              Logo güncellendi.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
